module.exports = __webpack_public_path__ + "static/wayne-thumbs-up-6fc9c7e9054dc85a37f85478d8252409.gif";